import { useEffect, useRef } from 'react';

const PROPS = ['--mx', '--my', '--tilt-x', '--tilt-y'] as const;

export function usePointerTilt<T extends HTMLElement>(): React.RefObject<T | null> {
  const ref = useRef<T>(null);

  useEffect(() => {
    const el = ref.current;
    if (!el) return;
    if (!window.matchMedia('(hover: hover) and (prefers-reduced-motion: no-preference)').matches) {
      return;
    }

    let frame = 0;
    const move = (event: PointerEvent): void => {
      cancelAnimationFrame(frame);
      frame = requestAnimationFrame(() => {
        const box = el.getBoundingClientRect();
        const x = (event.clientX - box.left) / box.width;
        const y = (event.clientY - box.top) / box.height;
        el.style.setProperty('--mx', `${(x * 100).toFixed(1)}%`);
        el.style.setProperty('--my', `${(y * 100).toFixed(1)}%`);
        el.style.setProperty('--tilt-x', (0.5 - y).toFixed(3));
        el.style.setProperty('--tilt-y', (x - 0.5).toFixed(3));
      });
    };
    const leave = (): void => {
      cancelAnimationFrame(frame);
      for (const prop of PROPS) el.style.removeProperty(prop);
    };

    el.addEventListener('pointermove', move);
    el.addEventListener('pointerleave', leave);
    return () => {
      cancelAnimationFrame(frame);
      el.removeEventListener('pointermove', move);
      el.removeEventListener('pointerleave', leave);
    };
  }, []);

  return ref;
}
